export enum GrantType {
    PASSWORD = 'password',
    CLIENT_CREDENTIALS = 'client_credentials',
    REFRESH_TOKEN = 'refresh_token',
    DEVICE = 'device'
}